import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../../../components/form/form-field';
import SaveButton from '../../../../../components/form/save-button';

const BatchTaskForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="batchTaskFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors.name?.message}
      />
      <FormField
        controlId="batchTaskFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.type?.message}
      />
      <FormField
        controlId="batchTaskFormFunction"
        label="function"
        name="function"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.function?.message}
        defaultValue="batch"
      />
      <FormField
        controlId="batchTaskFormId"
        label="id"
        name="parameters.id"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter ID"
        error={errors.parameters?.id?.message}
      />
      <FormField
        controlId="batchTaskFormInputBatchSize"
        label="inputBatchSize"
        name="parameters.inputBatchSize"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter input batch size"
        required
        error={errors.parameters?.inputBatchSize?.message}
      />
      <FormField
        controlId="batchTaskFormInputBatchFields"
        label="inputBatchFields"
        name="parameters.inputBatchFields"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter input batch fields"
        required
        error={errors.parameters?.inputBatchFields?.message}
      />
      <FormField
        controlId="batchTaskFormBatchedColumnAlias"
        label="batchedColumnAlias"
        name="parameters.batchedColumnAlias"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter batched column alias"
        error={errors.parameters?.batchedColumnAlias?.message}
      />
      <FormField
        controlId="batchTaskFormInputTable"
        label="inputTable"
        name="parameters.inputTable"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter input table"
        error={errors.parameters?.inputTable?.message}
      />
      <FormField
        controlId="batchTaskFormResult"
        label="result"
        name="parameters.result"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter result"
        error={errors.parameters?.result?.message}
      />
      <FormField
        controlId="batchTaskFormInputBatchGroupById"
        label="id"
        name="parameters.inputBatchGroupBy.id"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter ID to group by"
        error={errors.parameters?.inputBatchGroupBy?.id?.message}
      />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default BatchTaskForm;
